export default __webpack_public_path__ + "static/media/CVpolaroid_CityCollegePlymouth.a9e16abd.png";